export default __webpack_public_path__ + "static/media/vision.60d9a09c.png";